export const required = val => (val ? undefined : 'Required');
export const minLength = min => val => (val && val.trim().length < min ? `Must be at least ${min} characters` : undefined);
export const matches = (propAccessor, message) => (val, allVals) =>
  val === propAccessor(allVals) ? undefined : message;
export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined;



// WEBPACK FOOTER //
// ./src/services/Validators.js